<template>
  <div id="majorDomoScreen">
    <div id="letDown">
      <div class="letDownWrap">
        <div class="logoTitle">
          <img class="logo" src="@/assets/images/login/logo.png" alt="" />
          <img
            class="title"
            src="@/assets/images/login/title_picture.png"
            alt=""
          />
        </div>
        <div class="letDownBox">
          <div class="title" style="position: relative; height: 66px">
            <div
              style="
                display: flex;
                align-items: center;
                font-size: 25px;
                margin: 15px 0;
              "
            >
              <span
                style="
                  display: flex;
                  align-items: center;
                  cursor: pointer;
                  position: absolute;
                  z-index: 999;
                "
                @click="iconBack"
              >
                <v-icon
                  name="regular/arrow-alt-circle-left"
                  scale="1.5"
                ></v-icon>
              </span>
              <div
                class="title-content"
                style="width: 1024px; position: absolute; left: -24px"
              >
                <slot name="title"></slot>
              </div>
            </div>
          </div>
          <div class="form-wrap recruitment">
            <vue-scroll>
              <div class="scroll-content">
                <slot name="body"> </slot>
              </div>
            </vue-scroll>
          </div>
          <div class="btns">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-awesome/icons/regular/arrow-alt-circle-left";
import { ops } from "@/utils/scrollIndialog";
import { downloadByJs } from "@/utils/commen";
import {
  requiredItem,
  numberRequired,
  phoneRequired,
  isIdNumber,
} from "@/assets/js/formRules";
import { recommendMajorDomoSubmit } from "@/api/tempApi";
import qs from "qs";

export default {
  name: "PlayerRecommend",

  data() {
    return {
      requiredItem, // 表单校验方法
      numberRequired, // 表单校验方法
      phoneRequired, // 表单校验方法
      isIdNumber,
      staticUrl: "/uploads/templateFile/青训总监信息收集表.xlsx",
      uploadFileUrl: "/api/zuxie/guozi/upload/file",
      ops,
      tipsFlag: false, // 页面确认提交提示
      repeatSubmit: false, // 重复提交提示
      cancelFlag: false, // 页面取消提示
      formData: {
        idName: "",
        idNumber: "",
        level: "",
        phone: "",
        docUrl: "",
        organUuid: "",
        verificationCode: "",
      },
      fileList: [],
      formRules: {
        //   playerNum: [requiredItem('球员数量'),numberRequired('球员数量')],
        //   playerFileUrl: [requiredItem('报名表')],
      },
    };
  },

  computed: {},

  components: {
    "yioks-tips": () => import("@/components/YioksTip"),
  },

  methods: {
    iconBack() {
      // this.$router.go(-1);
      this.$emit('routerBack')
    },
    findProcess() {
      window.open(this.staticUrl);
    },

    checkForm() {
      this.$refs["vitaForm"].validate((valid) => {
        if (valid) {
          this.tipsFlag = true;
        } else {
          console.error("error submit validate!!");
          return false;
        }
      });
    },

    hideTipsDialog(bool) {
      if (bool) {
        if (!this.repeatSubmit) {
          this.repeatSubmit = true;
          this.formData.organUuid = this.orgUuid;
          this.formData.verificationCode = this.password;
          recommendMajorDomoSubmit(this.formData)
            .then((res) => {
              if (res.code) {
                this.$message.error(res.msg);
                return;
              }
              this.$message.success("信息提交成功");
              this.tipsFlag = false;
              this.$router.go(-1);
              this.repeatSubmit = false;
              this.$refs["vitaForm"].clearValidate();
            })
            .catch((err) => {
              console.error(err);
              this.repeatSubmit = false;
              this.tipsFlag = false;
            });
        }
      } else {
        this.repeatSubmit = false;
        this.tipsFlag = false;
      }
    },
    cancel() {
      this.cancelFlag = true;
    },
    goBack(isSure) {
      if (isSure) {
        this.$router.go(-1);
      }
      this.cancelFlag = false;
    },

    /* 文件上传成功 */
    fileUploadSuccess(res, file, fileList) {
      this.formData.docUrl = res;
      this.$refs.vitaForm.clearValidate(`docUrl`);
    },

    /* 文件上传校验 */
    fileUploadBefore(file) {
      const isLt10M = file.size / 1024 / 2014 < 10;
      const reg = /\.(xls|xlsx)$/i; // 检验文件后缀名，
      const isEndRight = reg.test(file.name);
      const isEXCEL =
        file.type === "application/vnd.ms-excel" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        isEndRight;
      if (!isLt10M) {
        this.$message.warning("上传文件不能大于20M");
      }
      if (!isEXCEL) {
        this.$message.warning("只允许上传EXCEL格式文件");
      }
      return isLt10M && isEXCEL;
    },
    fileRemove(file, fileList) {
      this.docUrl = "";
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
#majorDomoScreen
  width 100%
  height 100%
  font-size 14px
  #letDown
    height calc(100% - 60px)
    display flex
    justify-content center
    user-select none
    .letDownWrap
      width 1024px
      padding 95px 0 0
      display flex
      flex-direction column
      .logoTitle
        display flex
        justify-content center
        align-items center
        margin 0 0 50px 0
        .logo
          width 120px
          height 120px
          margin 0 15px 0 0
      .letDownBox
        align-self center
        width 1024px
        /* width: 1150px; */
        /* height: 550px; */
        height 610px
        padding 0 25px
        background-color $black_color
        box-shadow 2px 2px 2px rgba(0, 0, 0, 0.2)
        position relative
        color $color_white
        .title
          display flex
          justify-content space-between
          align-items center
          margin 10px 0 10px 0
          border-bottom 2px solid
          padding-bottom 10px
          h2
            font-size 25px
        .form-wrap
          height 460px
          .qualification-form-fieldset
            margin 0 0 20px 0
            padding 10px 10px 0
            border 1px solid $color_white
            .code
              width 150px
              margin-left 20px
              display inline-block
              line-height 1.5
              white-space nowrap
              cursor pointer
              text-align center
              outline none
              border-radius 4px
              padding 8px 16px
              background-color $color_suc
            .waittime
              background-color #909399
        .btns
          height 60px
          display flex
          justify-content center
          align-items center
    .form-content
      padding 120px 20px 120px 0
.yioks-btn
  background-color #4CD964
.back-icon
  width 24px
  height 24px
.scroll-content
  margin 0 15px
  padding-right 10px
.w_45
  width 45%
.w_100
  width 100%
.double-line
  width 60%
.el-upload__tip
  color #FFFFFF
  position relative
  .download-box
    position absolute
    top -35px
    left 90px
    color #4cd964
    text-decoration underline
    cursor pointer
.example
  position absolute
  right -37px
  font-size 16px
  top 10px
  .intro
    text-decoration underline
    cursor pointer
    color #4cd964
  .showExample
    display none
    position absolute
    width 400px
    left -200px
    z-index 999
    background-color white
    .nameExample
      /* text-align center */
      color black
      text-align center
    .img
      padding 0 20px 10px
      img
        width 100%
        height 100%
    &::before
      content ''
      position absolute
      top -8px
      left 200px
      border-bottom 8px solid white
      border-right 8px solid transparent
      border-left 8px solid transparent
  .showExampledouble
    display none
    position absolute
    width 600px
    left -300px
    z-index 999
    background-color white
    .nameExample
      /* text-align center */
      color black
      text-align center
    .img
      display flex
      padding 0 20px 10px
      .section
        .l_title
          font-size 14px
          color black
          text-align center
        img
          width 100%
          /* height 100% */
    &::before
      content ''
      position absolute
      top -8px
      left 300px
      border-bottom 8px solid white
      border-right 8px solid transparent
      border-left 8px solid transparent
  &:hover
    .showExample
      display block
    .showExampledouble
      display block
.w_d_100
  width 87%
  margin-left 30px
.w_l_100
  width 110%
.w_70
  width 70%
.w_80
  width 80%
.w_90
  width 90%
.w_l_120
  width 120%
.border-wrapper
  border 1px solid #FFFFFF
  padding 5px 10px
  position relative
  padding-bottom 50px
  margin-bottom 10px
  &:last-child
    margin-bottom 0
  .btns-wrapper
    width 120px
    height 30px
    display flex
    justify-content space-around
    align-items center
    position absolute
    bottom 15px
    left calc(50% - 60px)
.w140px
  width 140px
</style>
<style lang="stylus">
.form-wrap
  .el-form-item__label
    color #FFFFFF
  .continue_education
    width 53%
    margin-left 23px
  .vita-edu-row
    .el-range-separator
      padding 0
    .el-date-editor
      width 323px
    .orgPlace
      width 100%
  $width = 306px
  /* .birthday {
    .el-date-editor {
      width: $width;
    }
  } */
  .gender, .national
    .el-select
      width $width
.recruitment
  .el-icon-document
    color #FFFFFF
  .el-upload-list__item-name
    color #FFFFFF
  .el-radio__label
    color #FFFFFF
</style>
